import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectEscalationTable(state),
        type: 'escalation',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryEscalation,
    changeFilter: action.changeFilterEscalation,
    toggleSort: action.toggleSortEscalation,
    toggleMultiSort: action.toggleMultiSortEscalation,
    gotoPage: action.gotoPageEscalation,
    initialColumnsVisibility: action.initialTableSettingsEscalation,
    toggleColumnVisibility: action.toggleColumnVisibilityEscalation,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/EscalationSalesOrderSearchContainer.js